module.exports = "pegasus/assets/circle-twitter.gif";